import { createContext } from 'react';

export const IsDisabledContext = createContext<boolean>(false);
